import React from 'react';
import dynamic from 'next/dynamic';
import { NextRouter, useRouter } from 'next/router';

import { DJEDI_ABOUT_PATH, DJEDI_CONTACT_PATH } from 'consts/cms';

const STATIC_PAGES_MAP = {
  [DJEDI_ABOUT_PATH]: dynamic(() => import('./pages/AboutPage')),
  [DJEDI_CONTACT_PATH]: dynamic(() => import('./pages/ContactPage')),
} as const;

const getStaticPageComponent = (asPath: NextRouter['asPath']) => {
  return Object.entries(STATIC_PAGES_MAP).find(([path]) => asPath.includes(path))?.[1];
};

const StaticPage: React.FCWithChildren = ({ children, ...restProps }) => {
  const router = useRouter();

  const PageComponent = getStaticPageComponent(router.asPath);

  return PageComponent ? <PageComponent {...restProps}>{children}</PageComponent> : null;
};

export default StaticPage;
